export default {
  'zh-CN': {
    '00': '播放文件缺失',
    '01': '上传中',
    '02': '上传失败',
    '10': '上传成功',
    '20': '编码中',
    '30': '编码成功',
    '40': '编码失败',
    '50': '审核不通过',
    '##001': '视频禁止在小窗口播放，请关闭当前标签重新打开页面或重启浏览器继续播放！##001',
    '##002': '加密视频不支持在该浏览器上播放，请更换其它浏览器观看。##002',
    '##003': '跑马灯被篡改。'
  },
  'en': {
    '00': '播放文件缺失',
    '01': '上传中',
    '02': '上传失败',
    '10': '上传成功',
    '20': '编码中',
    '30': '编码成功',
    '40': '编码失败',
    '50': '审核不通过',
    '##001': '视频禁止在小窗口播放，请关闭当前标签重新打开页面或重启浏览器继续播放！##001',
    '##002': '加密视频不支持在该浏览器上播放，请更换其它浏览器观看。##002',
    '##003': '跑马灯被篡改。'
  }
}



// WEBPACK FOOTER //
// ./src/lang/index.js